import React from "react";
import { Badge } from "react-bootstrap";

const CustomBadge = ({ text, color }) => {
  const badgeStyle = {
    backgroundColor: color || "#0AA7FF",
    fontSize: "14px",
    fontWeight: "bold",
  };

  return (
    <div className="badge-status" style={badgeStyle}>
      <p>{text}</p>
    </div>
  );
};

export default CustomBadge;
